import styled from 'styled-components';

interface StyledWatermarkProps {
  backgroundImage: string;
  zIndex: number;
}

export const StyledWatermark = styled.div<StyledWatermarkProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  user-select: none;
  z-index: ${({ zIndex }) => zIndex};
  background-image: url('${({ backgroundImage }) => backgroundImage}');
  background-repeat: repeat;
  background-position: 0 0;
  /* Prevent text selection and interaction */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;
